import $ from "jquery";

const utilCheckboxRadio = () => {
    const init = () => {
        execute();
    };

    const execute = () => {
        const el = {
            main: ".js-checkbox-radio input",
        };

        if ($(el.main).length === 0) return;

        $(document).on("change", el.main, function () {
            const currentCheckbox = $(this);
            const parent = $(this).parentsUntil(".js-checkbox-radio").parent();

            const checkboxes = parent.find("input[type='checkbox']");
            checkboxes.not(currentCheckbox).prop("checked", false);
        });
    };
    init();
};

try {
    utilCheckboxRadio();
} catch (error) {
    console.error("utilCheckboxRadio", error);
}
